export var ProductType;
(function (ProductType) {
    ProductType["PHYSICAL"] = "PHYSICAL";
    ProductType["VOUCHER"] = "VOUCHER";
    ProductType["TICKET"] = "TICKET";
    ProductType["DIGITAL"] = "DIGITAL";
    ProductType["SERVICE"] = "SERVICE";
    ProductType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(ProductType || (ProductType = {}));
//# sourceMappingURL=product.type.js.map